import { useState, useEffect } from 'react'
import { getMediaTypes } from '../utils/helpers/supabase.helpers'
import { useSessionContext } from '../contexts/SessionContext'

interface MediaTypes {
  [key: number]: string
}

interface UseAgamiMediaTypesReturn {
  mediaTypes: MediaTypes | undefined
  isLoading: boolean
}

export const useAgamiMediaTypes = (): UseAgamiMediaTypesReturn => {
  const { loading, user } = useSessionContext()
  const [mediaTypes, setMediaTypes] = useState<MediaTypes | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const getAvailableMediaTypes = async (): Promise<void> => {
    const { data } = await getMediaTypes()
    const types = (data as { id: number; media_type: string }[] | undefined)?.reduce(
      (acc: MediaTypes, curr: { id: number; media_type: string }) => ({
        ...acc,
        [curr.id]: curr.media_type,
      }),
      {}
    )
    setMediaTypes(types)
    setIsLoading(false)
  }

  useEffect(() => {
    if (loading || !user?.id) {
      return
    }
    getAvailableMediaTypes()
  }, [loading, user])

  return { mediaTypes, isLoading }
}
